import { useWindowDimensions } from '@/hooks/use-window-dimensions';
import { composeClassName } from '@/utils/util_helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SubscriptionButtonProps {
  onSubscribe: () => void;
  isSubscribed: boolean;
  currentUser: any; // Replace with proper user type
  className?: string;
}

const SubscriptionButton: React.FC<SubscriptionButtonProps> = ({
  onSubscribe,
  isSubscribed,
  currentUser,
  className = '',
}) => {
  const { t } = useTranslation();
  const { screenIsLargeOrEqualThan } = useWindowDimensions();
  const isMobile = !screenIsLargeOrEqualThan('sm');

  return (
    <button
      type="button"
      onClick={onSubscribe}
      style={{
        paddingLeft: '24px',
        paddingRight: '24px',
        borderRadius: '8px',
      }}
      className={composeClassName(
        'items-center gap-2 bg-[#FECE1F] font-medium text-primary-100 hover:bg-opacity-90 sm:w-auto',
        isMobile ? 'py-2' : 'py-3',
        className
      )}
    >
      <span
        className={composeClassName(
          'text-center font-sans text-[16px] font-bold leading-[24px] text-N900',
          isMobile ? 'text-[14px]' : 'text-[16px]'
        )}
      >
        {isSubscribed
          ? t('js.components.house_details.unsubscribe_button')
          : t('js.components.house_details.subscribe_button')}
      </span>
    </button>
  );
};

export default SubscriptionButton;
